import { Skeleton } from "@/components/ui";

export const MedicalHistorySkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors"
      data-testid="medical-history-skeleton"
    >
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
};
